module.exports = __webpack_public_path__ + "img/dropbox.b3b56623.png";